import { cx } from "@/utils";

const VStack = ({ children, className, ...props }) => (
  <div {...props} className={cx("flex flex-col items-start gap-2", className)}>
    {children}
  </div>
);
export default VStack;
